import firebase from 'gatsby-plugin-firebase';

const logout = () => {
  firebase.auth().signOut();
};

export default logout;
